import React from 'react';
import Form from '../../../../common/components/Form';
import Input from '../../../../common/components/Input';
import SubmitButton from '@/common/components/buttons/SubmitButton';
import { Title, InputsContainer, OptionsContainer, InfoValue, AdditionalInfoItem, Splitter, WrapperBox, ItemsTitle, AdditionalInfoWrapper } from './InstantFormsEdit.styles';
import ActionButton from '@/common/components/buttons/ActionButton';
import SelectInput from '@/common/components/SelectInput';
import ToggleSwitch from '@/common/components/ToggleSwitch';
import { useHandleData } from '../hooks/useHandleData'
import { Colors } from '@/common/colors/colors';
import PopUp from '@/common/components/PopUp';


const InstantFormsEdit = ({ edit, setShow }) => {

    const {
        isActiveRef,
        fanpageRef,
        formIdRef,
        formNameRef,
        langFieldNameRef,
        additionalInfoRef,
        marketShort,
        variants,
        defaultProductVariant,
        price,
        prices,
        marketsOptions,
        additionalInfos,
        productShort,
        countryProducts,
        handleSubmit,
        handleMarketChange,
        handleProductChange,
        handleVariantChange,
        handlePriceChange,
        handleDeleteInfo,
        handleAddInfo
    } = useHandleData({ edit, setShow })


    return (
        <PopUp setShow={setShow}>
            <Title>Instant Form Panel</Title>
            <Form onSubmit={handleSubmit}>
                <InputsContainer>
                    <Input
                        inputRef={fanpageRef}
                        name='Fanpage'
                        required={true}
                        value={edit?.fanpage || ''}
                        width={180}
                        color={Colors.darkBlue}
                        requiredSign
                    />
                    <ToggleSwitch
                        toggleRef={isActiveRef}
                        checked={edit?.is_active || false}
                        width={140}
                        text={'In use:'}
                        requiredSign
                    />
                    <Input
                        inputRef={formIdRef}
                        name='Form ID'
                        required={true}
                        value={edit?.form_id || ''}
                        width={180}
                        color={Colors.darkBlue}
                        requiredSign
                    />
                    <Input
                        inputRef={formNameRef}
                        name='Form Name'
                        required={true}
                        value={edit?.form_name || ''}
                        width={180}
                        color={Colors.darkBlue}
                        requiredSign
                    />
                    <Input
                        inputRef={langFieldNameRef}
                        name='Lang Field Name'
                        required={true}
                        value={edit?.lang_field_name || ''}
                        width={180}
                        color={Colors.darkBlue}
                        requiredSign
                    />
                </InputsContainer>
                <Splitter />
                <OptionsContainer>
                    <SelectInput
                        name='Market'
                        color={Colors.darkBlue}
                        selected={marketShort}
                        setSelected={handleMarketChange}
                        options={marketsOptions}
                        width={100}
                        required

                    />
                    <SelectInput
                        name='Product'
                        color={Colors.darkBlue}
                        selected={productShort}
                        setSelected={handleProductChange}
                        options={countryProducts}
                        width={100}
                        required

                        disabled={!marketShort}
                    />
                </OptionsContainer>
                <Splitter />
                <OptionsContainer>
                    <SelectInput
                        name='Default Product Variant'
                        color={Colors.darkBlue}
                        selected={defaultProductVariant}
                        setSelected={handleVariantChange}
                        options={variants}
                        width={230}
                        required
                    />
                    <SelectInput
                        name='Price'
                        color={Colors.darkBlue}
                        selected={price}
                        setSelected={handlePriceChange}
                        options={prices}
                        width={100}
                        required
                    />
                </OptionsContainer>
                <Splitter />
                <AdditionalInfoWrapper>
                    <Input
                        color={Colors.darkBlue}
                        inputRef={additionalInfoRef}
                        name='Additional info'
                        value=''
                        width={150}
                        inputWidth={140}
                        type='string'
                        style={{ textAlign: "left", marginLeft: "20px" }}
                    />
                    <ActionButton
                        text='Add info'
                        onClick={handleAddInfo}
                    />
                </AdditionalInfoWrapper>
                <WrapperBox>
                    <ItemsTitle>Additional info:</ItemsTitle>
                    {additionalInfos?.length > 0
                        ? additionalInfos.map((info) => (
                            <AdditionalInfoItem
                                onClick={(e) => handleDeleteInfo(e, info._id)}
                            >
                                <InfoValue>{info.value}</InfoValue>
                            </AdditionalInfoItem>
                        ))
                        : ''}
                </WrapperBox>

                <SubmitButton
                    style={{ float: 'right', marginTop: '20px' }}
                    text='Save'
                />
            </Form>
        </PopUp>
    );
};

export default InstantFormsEdit;
